import {
  CheckboxField,
  Flex,
  Grid,
  Label,
  SelectField,
  TextField,
} from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";

import { days } from "config/constants";
import { globalStrings } from "config/translations/es";

const AlertSchedule = ({ form, onChange }) => {
  const onChangeInput = (e) => {
    let { name, value } = e.target;
    let valueMapped = value;

    if (name === "hourInterval" && valueMapped)
      valueMapped = Number(valueMapped);

    onChange(name, valueMapped);
  };

  const onChangeDays = (name, value) => {
    if (value)
      onChange("days", form.days?.length > 0 ? [...form.days, name] : [name]);
    else
      onChange(
        "days",
        form.days?.filter((d) => d !== name)
      );
  };

  const onChangeCheckbox = (e) => {
    let { name, checked } = e.target;

    onChange(name, checked);
  };

  return (
    <>
      <div className="fs-5">{strings.title}</div>
      <Grid
        rowGap="15px"
        columnGap="15px"
        templateColumns={{ large: "1fr 1fr 1fr 1fr" }}
      >
        <SelectField
          name="execInterval"
          value={form.execInterval || ""}
          label={strings.fields.execInterval.label}
          onChange={onChangeInput}
        >
          <option value="hour">
            {strings.fields.execInterval.options.hour}
          </option>
          <option value="day">{strings.fields.execInterval.options.day}</option>
        </SelectField>
        {form.execInterval === "day" ? (
          <TextField
            name="execTime"
            type="time"
            label={strings.fields.execTime.label}
            value={form.execTime || ""}
            onChange={onChangeInput}
          ></TextField>
        ) : (
          <>
            <Grid>
              <Label>{strings.fields.hourInterval.label}</Label>
              <Flex gap="5px" alignItems="center">
                <span>{strings.fields.hourInterval.each}</span>
                <TextField
                  name="hourInterval"
                  type="number"
                  value={form.hourInterval ?? 1}
                  min={0}
                  onChange={onChangeInput}
                ></TextField>
                <span>{strings.fields.hourInterval.hours}</span>
              </Flex>
            </Grid>
            <TextField
              name="startSchedule"
              type="time"
              label={strings.fields.startSchedule.label}
              value={form.startSchedule || ""}
              onChange={onChangeInput}
            ></TextField>
            <TextField
              name="endSchedule"
              type="time"
              label={strings.fields.endSchedule.label}
              value={form.endSchedule || ""}
              onChange={onChangeInput}
            ></TextField>
          </>
        )}
      </Grid>
      <Grid>
        <Label className="mb-1">{strings.fields.days.label}</Label>
        <Flex wrap="wrap">
          {days.map((day) => (
            <CheckboxField
              label={globalStrings.dayNames[day]}
              checked={form.days?.some((d) => d === day) || false}
              onChange={(e) => onChangeDays(day, e.target.checked)}
            />
          ))}
        </Flex>
      </Grid>
      <Grid>
        <Flex gap="10px">
          <Label>{strings.fields.executeOnHolidays.label}</Label>
          <CheckboxField
            name="executeOnHolidays"
            checked={form.executeOnHolidays || false}
            onChange={onChangeCheckbox}
          />
        </Flex>
      </Grid>
    </>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Horario de Ejecución",
    fields: {
      startSchedule: {
        label: "Hora de Inicio",
      },
      endSchedule: {
        label: "Hora de Fin",
      },
      days: {
        label: "Día de la Semana",
      },
      executeOnHolidays: {
        label: "Ejecutar en días festivos",
      },
      execInterval: {
        label: "Intervalo de Ejecución",
        options: {
          hour: "Por Hora",
          day: "Por Día",
        },
      },
      execTime: {
        label: "Hora de Ejecución",
      },
      hourInterval: {
        label: "Intervalo de Horas",
        each: "Cada",
        hours: "Hora/s",
      },
    },
  },
});

export default AlertSchedule;
